<div class="page-layout">

  <div class="page-header">
    <div class="header-title-group">
      <h1 class="cyber-title">>_ GESTOR DE EJECUCIONES (DRAG & DROP)</h1>
      <p class="subtitle">Proyecto: <strong>{{ project?.name }}</strong></p>
    </div>
    <div class="header-actions">
      <button class="btn secondary" (click)="goBack()">
        <svg viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
        Volver
      </button>
      <button class="btn primary btn-glow" (click)="saveChanges()">
        <svg viewBox="0 0 24 24"><path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"/></svg>
        Guardar Cambios
      </button>
    </div>
  </div>

  <div class="board-layout">
    <div class="sidebar-zone col-1">
      <div class="drop-zone orphan-zone">
        <h4 class="zone-title" style="color: #ffbd2e;">⚠️ No Planificadas</h4>
        <p class="zone-desc">Ejecuciones sin estimación.</p>

        <div
          id="unplannedList"
          class="execution-list"
          cdkDropList
          [cdkDropListData]="unplannedExecutions"
          [cdkDropListConnectedTo]="connectedDropLists"
          (cdkDropListDropped)="drop($event)">

          <div class="exec-card" *ngFor="let exec of unplannedExecutions" cdkDrag>
            <div class="exec-title">{{ exec.name || exec.description }}</div>
            <div class="exec-meta">
              <span class="badge">{{ exec.profile || 'Dev' }}</span>
              <span class="hours">{{ exec.executedtime || exec.hours || 0 }}H</span>
            </div>
          </div>

          <div class="empty-placeholder" *ngIf="unplannedExecutions.length === 0">Bandeja vacía.</div>
        </div>
      </div>

      <div class="drop-zone trash-zone">
        <h4 class="zone-title" style="color: #ff5f56;">🗑️ Papelera</h4>
        <p class="zone-desc">Arrastra para eliminar.</p>

        <div
          id="trashList"
          class="execution-list trash-list"
          cdkDropList
          [cdkDropListData]="trashExecutions"
          [cdkDropListConnectedTo]="connectedDropLists"
          (cdkDropListDropped)="drop($event)">

          <div class="exec-card deleted-card" *ngFor="let exec of trashExecutions" cdkDrag>
            <div class="exec-title"><del>{{ exec.name || exec.description }}</del></div>
          </div>

          <div class="empty-placeholder" *ngIf="trashExecutions.length === 0">Papelera vacía.</div>
        </div>
      </div>
    </div>

    <div class="sidebar-zone col-2">
      <div class="drop-zone transversal-zone">
        <h4 class="zone-title" style="color: #8be9fd;">🔄 Transversales</h4>
        <p class="zone-desc">Ejecuciones globales del proyecto.</p>
        
        <div 
          id="transversalList"
          class="execution-list"
          cdkDropList
          [cdkDropListData]="transversalExecutions"
          [cdkDropListConnectedTo]="connectedDropLists"
          (cdkDropListDropped)="drop($event)">
          
          <div class="exec-card transversal-card" *ngFor="let exec of transversalExecutions" cdkDrag>
            <div class="exec-title">{{ exec.name || exec.description }}</div>
            <div class="exec-meta">
              <span class="badge">{{ exec.profile || 'Dev' }}</span>
              <span class="hours transversal-hours">{{ exec.executedtime || exec.hours || 0 }}H</span>
            </div>
          </div>
          
          <div class="empty-placeholder" *ngIf="transversalExecutions.length === 0">Bandeja vacía.</div>
        </div>
      </div>
    </div>

    <div class="main-zone col-3">
      <div class="empty-state" *ngIf="plannedGroups.length === 0">
        >_ No hay tareas planificadas en este proyecto.
      </div>

      <div class="requirement-group" *ngFor="let group of plannedGroups">
        <h4 class="req-header">{{ group.reqName }}</h4>
        
        <div class="task-grid-horizontal">
          <div class="task-drop-container surface" *ngFor="let taskObj of group.tasks">
            
            <div class="task-info">
              <span class="task-name">{{ taskObj.task.name || taskObj.task.description }}</span>
              <span class="task-est-hours">Est: {{ taskObj.task.estimatetime || 0 }}H</span>
            </div>
            
            <div 
              [id]="taskObj.dropId"
              class="execution-list horizontal-drop"
              cdkDropList
              [cdkDropListData]="taskObj.executions"
              [cdkDropListConnectedTo]="connectedDropLists"
              (cdkDropListDropped)="drop($event)">
              
              <div class="exec-card horizontal-card" *ngFor="let exec of taskObj.executions" cdkDrag>
                <div class="exec-title">{{ exec.name || exec.description }}</div>
                <div class="exec-meta">
                  <span class="badge">{{ exec.profile || 'Dev' }}</span>
                  <span class="hours real-hours">{{ exec.executedtime || exec.hours || 0 }}H</span>
                </div>
              </div>

              <div class="empty-placeholder drop-hint horizontal-hint" *ngIf="taskObj.executions.length === 0">
                Soltar aquí...
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>

  </div>
</div>